import Authorization from "policies/Authorization";
import Codenames from "policies/Codenames";
import React from "react";
import LastSyncedAt from "./LastSyncedAt";
import SyncSites from "./SyncSites";

export default function syncMenu({ applicationContext, policy }) {
  if (!policy.canSync(Authorization.EntityTypes.SyncResult)) return null;

  return {
    items: [
      {
        name: "Sync",
        render: () => <SyncSites label={`Sync current site with the ${Codenames.Packmanager}`} />,
      },
      // Can timeout. Should start with the site synced earliest/not at all
      policy.canSyncAll(Authorization.EntityTypes.SyncResult) && {
        name: "Sync all sites",
        render: () => <SyncSites all label={`Sync all sites with the ${Codenames.Packmanager}`} />,
      },
      {
        name: "Last synced at",
        render: () => <LastSyncedAt lastSyncedAt={applicationContext.site.lastSyncedAt} />,
      },
    ],
    name: "Sync",
  };
}
